import React, { useCallback, useState } from 'react';

import EmployeesEdit from 'components/EmployeesEdit';
import { MultiEmployeeOnlyPhotoLabel } from 'components/SearchComponent';
import { StyledAvatar } from 'components/avatars';
import { useOwnersState } from 'components/hooks/employee';
import EmployeeEditPopup from 'components/popup/EmployeeEditPopup';
import { StyledNodesView } from 'screens/common/sidepanel/sidepanelStyles';
import styled from 'styled-components';

import { AddPeerIcon } from 'constants/icons';

import { selectOwners } from 'services/helpers/task';

export default function OwnerField({ taskDetails, updateTask, className, filterEmpIds = null }) {
  const { currentOwners } = useOwnersState(selectOwners(taskDetails.toIds || []));
  const [ownerPopupAnchor, setOwnerPopupAnchor] = useState(null);

  const onUpdate = useCallback(
    (employees) => {
      updateTask(
        {
          ...taskDetails,
          toIds: employees,
          overrideToIds: false,
        },
        false
      );
    },
    [JSON.stringify(taskDetails)]
  );

  return (
    <StyledNodesView
      className={`${className} styledNodesView`}
      // rightGutter={1}
      employees={currentOwners}
      maxNodes={5}
      useEmployeeClick={false}
      renderEmptyView={(props) => (
        <AddPeerIcon
          {...props}
          color="white"
          circular
          size="fixed24px"
          style={{ marginLeft: currentOwners?.length ? '-6px' : '0px' }}
        />
      )}
      renderAvatar={(props) => <StyledAvatar {...props} size="fixed28px" leftGutter={-1} border="2px solid #EAEAEA" />}
      onClick={(e) => {
        e.preventDefault();
        setOwnerPopupAnchor(ownerPopupAnchor ? null : e.currentTarget);
      }}
      renderNodesEditView={() => (
        <EmployeeEditPopup
          id={`${taskDetails.id}-owner-popper`}
          anchorEl={ownerPopupAnchor}
          setAnchor={setOwnerPopupAnchor}
          popperProps={{
            disablePortal: true,
          }}
        >
          <StyledEmployeesEdit employees={taskDetails.toIds} onUpdate={onUpdate}>
            <StyledEmployeesEdit.OwnersEdit
              filterEmpIds={filterEmpIds}
              teamId={null}
              reactSelectComponentsOverride={{ MultiValueLabel: MultiEmployeeOnlyPhotoLabel }}
            />
          </StyledEmployeesEdit>
        </EmployeeEditPopup>
      )}
    />
  );
}

const StyledEmployeesEdit = styled(EmployeesEdit)`
  padding: 24px;
  background: white;
  box-shadow: ${(props) => props.theme.shadows[1]};
  border-radius: 4px;
`;
